package com.islamicmedia.shared.data.storage

import kotlinx.browser.localStorage

actual class KidsModeStore {
    actual fun getString(key: String): String? = try { localStorage.getItem("kids_$key") } catch (_: Throwable) { null }

    actual fun putString(key: String, value: String?) {
        try {
            if (value == null) localStorage.removeItem("kids_$key") else localStorage.setItem("kids_$key", value)
        } catch (_: Throwable) { }
    }
}
